import { PERMISSIONS } from '../../../Permissions'
import { EVAL_STATE } from '../SingleEvaluationForm/evaluationForm.constants'

// these are multipliers for theme.spacing
export const PANEL_SIZES = {
  SENTIMENT: 14,
  TRANSCRIPTION: 40,
  TIMELINE: 5,
  AUDIO: 14,
  SPEECH: 19,
  DESKTOP: 25,
  CHAT: 40,
}

export const SCROLL_ALIGNMENT_FRACTION = 4

export const canEvaluationComponentRender = (authenticatedUser, { evalStateId, agentId, evaluatorId }) => {
  const { user, hasAllPermissions, hasPermission } = authenticatedUser
  if (!hasPermission(PERMISSIONS.VIEW_EVALUATIONS)) {
    return false
  }

  const userIsContactAgent = user.id === agentId
  const userIsContactEvaluator = user.id === evaluatorId

  if (userIsContactEvaluator || hasPermission(PERMISSIONS.EDIT_ANY_EVALUATION)) {
    // user can see all eval states of the evaluation
    return true
  }

  if (
    (!userIsContactAgent &&
      !userIsContactEvaluator &&
      hasAllPermissions([PERMISSIONS.EVALUATE_QUALITY_CONTACT, PERMISSIONS.APPROVE_QUALITY_CONTACT])) ||
    (userIsContactAgent &&
      !userIsContactEvaluator &&
      hasAllPermissions([PERMISSIONS.SELF_EVALUATE_QUALITY_CONTACT, PERMISSIONS.SELF_APPROVE_QUALITY_CONTACT]) &&
      !hasPermission(PERMISSIONS.EDIT_ANY_EVALUATION))
  ) {
    // user can see unscored, approval and terminal eval states of the evaluation
    return [
      EVAL_STATE.UNSCORED,
      EVAL_STATE.NEEDS_CANNOT_SCORE_APPROVAL,
      EVAL_STATE.NEEDS_APPROVAL,
      EVAL_STATE.CANNOT_SCORE,
      EVAL_STATE.SCORED,
    ].includes(evalStateId)
  }

  if (
    (userIsContactAgent &&
      !hasPermission(PERMISSIONS.EVALUATE_QUALITY_CONTACT) &&
      hasPermission(PERMISSIONS.SELF_APPROVE_QUALITY_CONTACT)) ||
    (userIsContactAgent &&
      hasAllPermissions([PERMISSIONS.EVALUATE_QUALITY_CONTACT, PERMISSIONS.SELF_APPROVE_QUALITY_CONTACT]) &&
      !hasAllPermissions([PERMISSIONS.SELF_EVALUATE_QUALITY_CONTACT, PERMISSIONS.EDIT_ANY_EVALUATION])) ||
    (!userIsContactAgent &&
      !hasPermission(PERMISSIONS.EVALUATE_QUALITY_CONTACT) &&
      hasPermission(PERMISSIONS.APPROVE_QUALITY_CONTACT))
  ) {
    // user can see approval and terminal eval states of the evaluation
    return [
      EVAL_STATE.NEEDS_CANNOT_SCORE_APPROVAL,
      EVAL_STATE.NEEDS_APPROVAL,
      EVAL_STATE.CANNOT_SCORE,
      EVAL_STATE.SCORED,
    ].includes(evalStateId)
  }

  if (
    (userIsContactAgent &&
      !userIsContactEvaluator &&
      hasPermission(PERMISSIONS.SELF_EVALUATE_QUALITY_CONTACT) &&
      !hasPermission(PERMISSIONS.EDIT_ANY_EVALUATION)) ||
    (!userIsContactAgent &&
      !userIsContactEvaluator &&
      hasPermission(PERMISSIONS.EVALUATE_QUALITY_CONTACT) &&
      !hasAllPermissions([PERMISSIONS.EDIT_ANY_EVALUATION, PERMISSIONS.APPROVE_QUALITY_CONTACT]))
  ) {
    // user can see unscored and terminal states of the evaluation
    return [EVAL_STATE.UNSCORED, EVAL_STATE.CANNOT_SCORE, EVAL_STATE.SCORED].includes(evalStateId)
  }

  // user can see terminal eval states of the evaluation
  return [EVAL_STATE.CANNOT_SCORE, EVAL_STATE.SCORED].includes(evalStateId)
}

export const canCalibrationComponentRender = (authenticatedUser, agentId, isCalibration) => {
  const { hasPermission, user } = authenticatedUser

  return isCalibration && ((user.id !== agentId && hasPermission(PERMISSIONS.CALIBRATE_CONTACT))
                       ||  (user.id === agentId && hasPermission(PERMISSIONS.SELF_CALIBRATE_CONTACT)))
}
